// extracted by mini-css-extract-plugin
module.exports = {"lock":"components-ContentHeader-LockCalculation-LockCalculation__lock--1zKZT","lock-disabled":"components-ContentHeader-LockCalculation-LockCalculation__lock-disabled--cRL2v"};